<template>
  <div class="LKMunMehHostViewForm">
    <div class="LKMunMehHostViewForm__content">
      <div class="LKMunMehHostViewForm__content__link">
        <v-row>
          <v-col cols="12">
            <h3
              class="LKMunMehHostViewForm__title"
              v-text="munMeh.name"
            />
          </v-col>
        </v-row>
      </div>

      <hr class="LKMunMehHostViewForm__line">

      <LogsTable
        :form="form"
        :indicator-ids-with-logs="getIndicatorIdsWithLogs()"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
const LogsTable = () => import(
  /* webpackChunkName: "LKMunMehLogsList" */
  '@/views/LKMunMeh/components/LKMunMehLogsList.vue'
)

import { LKMunMehReviewMapper as StoreMapper } from '../store'

export default {
  name: 'LKMunMehHostViewLogs',
  components: {
    LogsTable,
  },
  props: {
    munMeh: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...StoreMapper.mapGetters(['getIndicatorIdsWithLogs']),
  },
}
</script>

<style lang="scss">
.LKMunMehHostViewForm {
  @import "~@/views/LKMunMeh/styles/_MunMehFormStylesheet.scss";
}
</style>
